// client/src/lib/externalReturn.ts
/**
 * "The client came back from an off-app page" (the in-app browser was dismissed, or the app returned to
 * the foreground — e.g. from the payment page or a UPI app). client-app announces it; pages that show
 * money refetch, so a completed payment shows without a manual reload (owner 2026-11-04).
 * The web never announces it (no listener cost beyond one addEventListener).
 */
export const EXTERNAL_RETURN_EVENT = "lm:external-return";

const defaultTarget = (): EventTarget | null => (typeof window !== "undefined" ? window : null);

export function announceExternalReturn(target: EventTarget | null = defaultTarget()): void {
  if (!target) return;
  try { target.dispatchEvent(new CustomEvent(EXTERNAL_RETURN_EVENT)); } catch { /* ignore */ }
}

/** Subscribe; returns the unsubscribe (use as a useEffect cleanup). */
export function onExternalReturn(cb: () => void, target: EventTarget | null = defaultTarget()): () => void {
  if (!target) return () => {};
  const h = () => cb();
  target.addEventListener(EXTERNAL_RETURN_EVENT, h);
  return () => target.removeEventListener(EXTERNAL_RETURN_EVENT, h);
}

type QC = { invalidateQueries(filters: { queryKey: readonly unknown[] }): unknown };

/** The invoice reads a payment changes: the wedding's list, the payment status, every /api/inv/<token> summary. */
export function refreshInvoiceQueries(qc: QC, weddingId: number | string | null | undefined): void {
  if (weddingId != null) qc.invalidateQueries({ queryKey: ["/api/weddings", weddingId, "invoices"] });
  qc.invalidateQueries({ queryKey: ["/api/invoices/payment-status"] });
  qc.invalidateQueries({ queryKey: ["/api/inv"] });
}
